<template>
  <span>{{ fechaComponent }}</span>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  name: "fechaComponent",
  computed: {
    fechaComponent() {
      if (this.params.data.fecha_compromiso)
        return this.$moment(this.params.data.fecha_compromiso).format(
          "DD/MM/YYYY",
        );
      return null;
    },
  },
});
</script>
